import React, { Component, Fragment } from "react"
import { includes, uniq, isEmpty, isNil, head, find, orderBy } from "lodash"
import { withStyles } from "@material-ui/core/styles"
import { compose } from "recompose"
import { connect } from "react-redux"
import styles from "./styles"
import MainAppBar from "../../components/MainAppBar"
import { Button, Typography, Popover, Fab, Box } from "@material-ui/core"
import {
  toggleShootDialog,
  toggleEditShootDialog,
  setEditShoot,
  shootsByCrew,
  getCalenderShoots,
  clearShoots,
  getShootbyId,
} from "../../actions/shoots"
import {
  saveDefaultFilters,
  getDefaultFilters,
  removeDefaultFilters,
} from "../../actions/users"
import { getUsers, getRoles } from "../../actions/misc"
import { getShoots } from "../../actions/shoots"
import TabBar from "../../components/TabBar"
import FilterDialog, { filterOptions } from "./filterDialog"
import FilterBar from "./filterBar"
import CalendarHeaderToolbar from "./calendarToolbar"
import CreatorFilterDialog from "./creatorFilterDialog"
import FilterPreferencesDialog from "./filterPreferencesDialog"
import CustomActionBar from "./customActionBar"
import FullCalendar from "@fullcalendar/react"
import dayGridPlugin from "@fullcalendar/daygrid"
import listPlugin from "@fullcalendar/list"
import green from "@material-ui/core/colors/green"
import CircularProgress from "@material-ui/core/CircularProgress"
import Hidden from "@material-ui/core/Hidden"
import { sortOptions } from "./sortBy"
import { dateOptions } from "./dateFilter"
import $ from "jquery"
import "@fullcalendar/list/main.css"
import "@fullcalendar/daygrid/main.css"
import moment from "moment"
import { convertToAbbr } from "../../lib/states.js"
import EditShootDialog from "../../components/EditShootDialog/index"
import DuplicateConfirmDialog from "../../components/DuplicateShootConfirmDialog/index"

import Image from "../../assets/images/login_bg.jpg"

import { getCrew } from "../../actions/crew"

import Avatar from "@material-ui/core/Avatar"
import AddIcon from "@material-ui/icons/Add"
import { openSnackBar } from "../../actions/snack-bar"
import LoadingOverlay from "react-loading-overlay"
import CrewMamaAppBarComponent from "../../components/CrewmamaAppBar"
import { getCurrentHost } from "../../utils/getHost"
import ShootCard from "../../components/ShootCard"
import InfiniteScroll from "react-infinite-scroll-component"
import { getClientCompanies } from "../../actions/clients"

function addDays(date, days) {
  var result = new Date(date)
  result.setDate(result.getDate() + days)
  return result
}

var isDate = function(date) {
  return new Date(date) !== "Invalid Date" && !isNaN(new Date(date))
}
// CHECK FOR THE MOBILE VIEW
const isMobile = window.innerWidth < 600

const shootsPerPage = 50

class MyShoots extends Component {
  constructor(props) {
    super(props)
    this.state = {
      searchKey: false,
      search: "",
      sort: null,
      creatorFilters: [],
      filters: [],
      showDialog: false,
      creatorsAnd: false,
      and: false,
      dateFilter: null,
      startDate: null,
      endDate: null,
      creatorFilter: null,
      showCreatorFilterDialog: false,
      showFilterPreferencesDialog: false,
      popover: {
        func: () => "",
        anchor: null,
      },
      crewShoots: [],
      isCalendarView: false,
      isListView: true,
      eventPopoverEl: null,
      eventPopoverShoot: null,
      currentPage: 1,
      flag: 1,
      sort_shoots: false,
      height: null,
      eventPopoverPosition: {
        top: 0,
        left: 0,
      },
      dateSetStrDate: null,
      dateSetEndDate: null,
      minDateSetStrTime: null,
      maxDateSetEndTime: null,
      searchTimeout: null,
      isLoading: true,
      isLoadingShoots: true,
      defaultFiltersSwitch: false,
      toggleFilterSwitch: true,
      dateShowTitle: "",
      dateOptions: [
        {
          value: 1,
          label: "Week",
        },
        {
          value: 2,
          label: "Day",
        },
        {
          value: 3,
          label: "Month",
        },
      ],
      viewOptions: [
        {
          value: 1,
          label: "Cards",
        },
        {
          value: 2,
          label: "Calendar",
        },
        {
          value: 3,
          label: "List",
        },
      ],
      defaultDateOption: {
        value: 3,
        label: "Month",
      },
      defaultViewOption: {
        value: 1,
        label: "Cards",
      },
      collapsedEventId: null,
      cardStartDate: null,
      cardEndDate: null,
    }
    this.fullCalendar = React.createRef()
  }

  componentWillUnmount() {
    this.props.dispatch(clearShoots())
  }
  componentDidUpdate(p) {
    // console.log('look here', this)
    // debugger;
    // This is how I am getting the loading spinner to stop
    // It is currently bugged for users with no shoots
    if (
      this.state.isLoadingShoots === true &&
      this.props.shoots &&
      this.props.shoots.length
    ) {
      this.setState({
        isLoadingShoots: false,
      })
    }
    // else if(this.state.isLoadingShoots === true && this.props.shoots.length === 0) {
    //   this.setState({
    //     isLoadingShoots: false,
    //   })
    // }
    if (p.activeCompany !== this.props.activeCompany) {
      // if (this.props.shoots && this.props.shoots.length) {

      if (
        this.state.isCalendarView === true ||
        this.state.isListView === true ||
        localStorage.getItem("shootsView") === "calendar"
      ) {
      } else {
        this.setState({ currentPage: 1, isLoading: true })
      }

      this.props.dispatch(clearShoots())
      let sending = {}
      let filter = []
      let dateFilter = {}
      let sort = this.state.sort
      const activeCompany = this.props.activeCompany
      let creatorName = this.state.creatorFilters
      let searchKey = this.state.search
      sending.searchKey = searchKey
      sending.creatorFilter = creatorName
      sending.sort = sort
      sending.activeCompany = activeCompany
      sending.and = this.state.and
      if (this.state.dateFilter != null) {
        dateFilter = this.state.dateFilter
        sending.id = dateFilter.id
        sending.dateFiltername = dateFilter.name

        if (
          dateFilter.name === "Specific Range" &&
          this.state.startDate != null &&
          this.state.endDate != null
        ) {
          // sending.id = dateFilter.id
          sending.startDate = this.state.startDate
          sending.endDate = this.state.endDate
        } else {
          sending.startDate = null
          sending.endDate = null
        }
      } else {
        dateFilter.id = 1
      }

      if (this.state.filters != null) {
        filter = this.state.filters
        sending.filter = filter
      } else {
        filter = null
        sending.filter = filter
      }

      if (
        this.state.isCalendarView ||
        this.state.isListView ||
        localStorage.getItem("shootsView") === "calendar"
      ) {
        sending.startDate = localStorage.getItem("dateSetStrDate")
        sending.endDate = localStorage.getItem("dateSetEndDate")
        this.props.dispatch(getCalenderShoots(sending))
        this.setState({
          isLoading: false,
        })
      } else {
        // debugger;
        this.setState({
          isLoadingShoots: false,
        })
        this.props.dispatch(
          getShoots(this.state.currentPage, sending, dateFilter.id)
        )
      }

      this.setState({
        isLoadingShoots: false,
      })
    }
  }

  async componentDidMount() {
    const { authenticatedUser } = this.props
    const { defaultViewOption } = this.state

    // console.log('in MyShoots NOT Shoots')

    // console.log('state', this.state);

    let creator = [
      {
        id: authenticatedUser.id,
        first_name: authenticatedUser.first_name,
        last_name: authenticatedUser.last_name,
        type: "creator",
        name: `${authenticatedUser.first_name} ${authenticatedUser.last_name}`,
      },
    ]

    this.setState({
      isLoading: true,
    })
    this.props.companyList.length === 0 &&
      this.props.dispatch(getClientCompanies())

    let searchKey = ""
    if (localStorage.shootsSearch) {
      searchKey = localStorage.getItem("shootsSearch")
      this.setState({ search: searchKey })
    }

    // This might not be the best way to go about this
    // Trying to get the real start/end dates. Not sure if it'll matter either way
    const dateRangeStartDate = moment()
      .startOf("month")
      .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
    const dateRangeEndDate = moment()
      .endOf("month")
      .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })

    // console.log('props', this.props)

    let sending = {}
    // set activecompany for crewmama
    const activeCompany = this.props.activeCompany || 2
    sending.searchKey = searchKey
    sending.creatorFilter = creator
    sending.activeCompany = activeCompany
    sending.startDate = dateRangeStartDate
    sending.endDate = dateRangeEndDate

    const title = `${moment()
      .startOf("month")
      .format("MMM YYYY")}`

    let startDateStr,
      endDatestr = ""

    startDateStr = dateRangeStartDate
    endDatestr = dateRangeEndDate

    sending.filter = []

    this.setState({
      creatorFilters: creator,
      dateShowTitle: title,
      cardStartDate: startDateStr,
      cardEndDate: endDatestr,
    })
    this.props.dispatch(getCalenderShoots(sending))

    this.props.dispatch(getRoles())
    this.props.dispatch(getUsers())
    // Changed below to call getCalendarShoots instead of getCrewShootsNew
    // Because calling getCrewShootsNew will fail and crash if there are no shoots in the date range
    // Would likely need to change the backend to make it return an empty array for no shoots instead of just a message that says "no shoots"
    // Might need to change
    // this.props.dispatch(getCalenderShoots(sending)).then(res => {
    //   // console.log("resssss", res)
    //   if (!isEmpty(res)) {
    //     this.setState({ crewShoots: res })
    //   } else {
    //     this.setState({ isLoadingShoots: false, isLoading: false })
    //   }
    //   this.setState({ crewShoots: res })
    //   // console.log(this.state.crewShoots)
    // })
    this.props.dispatch(shootsByCrew(sending)).then(res => {
      // console.log("resssss", res)
      if (!isEmpty(res)) {
        this.setState({ crewShoots: res })
      } else {
        this.setState({ isLoadingShoots: false, isLoading: false })
      }
      this.setState({ crewShoots: res })
      // console.log(this.state.crewShoots)
    })
    this.setState({ isLoadingShoots: false, isLoading: false })

    this.setState({ flag: 0, isLoading: false })
  }

  applyDefaultFilters = async () => {
    //continue from here
    const { defaultFilters } = this.props
    await this.setState({
      filters: [],
      creatorFilters: [],
    })

    let statusFilters = JSON.parse(defaultFilters.filters).statusOptions

    let creatorOptions = JSON.parse(defaultFilters.filters).creatorsOptions

    if (uniq(statusFilters).length > 0) {
      localStorage.setItem(
        "shootsFilters",
        JSON.stringify({
          filters: uniq(statusFilters).map(x => x.id),
        })
      )
    }

    localStorage.setItem(
      "shootsCreatorFilters",
      JSON.stringify(
        creatorOptions.map(x => {
          return { ...x, func: undefined }
        })
      )
    )
    this.setState(
      { creatorFilters: creatorOptions, filters: uniq(statusFilters) },
      () => {
        this.onChangeCreatorFilter(this.state.creatorFilters)
      }
    )
  }

  setDate = (startDate, endDate) => {
    if (startDate != null && endDate != null) {
      let sDate = new Date(startDate).toISOString()
      let eDate = new Date(endDate).toISOString()

      this.setState({ startDate: sDate })
      this.setState({ endDate: eDate })
    }
  }

  toggleHideFilters = async bool => {
    await this.setState({
      toggleFilterSwitch: bool,
    })
  }

  setFilter = (filters, and = this.state.and) => {
    this.setState({
      isLoading: true,
    })

    if (isEmpty(filters)) {
      localStorage.removeItem("shootsFilters")
    }

    if (this.state.isCalendarView === true || this.state.isListView === true) {
    } else {
      this.setState({ currentPage: 1 })
    }
    let sending = {}
    let filter = []
    let dateFilter = {}
    let sort = this.state.sort
    const activeCompany = this.props.activeCompany
    let creatorName = this.state.creatorFilters
    sending.creatorFilter = creatorName
    let searchKey = this.state.search
    sending.searchKey = searchKey
    sending.sort = sort
    sending.activeCompany = activeCompany

    sending.and = and

    if (this.state.dateFilter != null) {
      dateFilter = this.state.dateFilter
      sending.id = dateFilter.id
      sending.dateFiltername = dateFilter.name
      if (
        dateFilter.name === "Specific Range" &&
        this.state.startDate != null &&
        this.state.endDate != null
      ) {
        sending.id = dateFilter.id
        sending.startDate = this.state.startDate
        sending.endDate = this.state.endDate
      } else {
        sending.startDate = null
        sending.endDate = null
      }
    } else {
      dateFilter.id = 1
    }

    if (this.state.filters != null) {
      filter = filters
      sending.filter = filter
    } else {
      filter = null
      sending.filter = filter
    }
    if (this.state.isCalendarView === true || this.state.isListView === true) {
      sending.startDate = this.state.dateSetStrDate
      sending.endDate = this.state.dateSetEndDate
      this.props.dispatch(clearShoots())
      this.props.dispatch(getCalenderShoots(sending))
    } else {
      this.props.dispatch(clearShoots())

      this.props.dispatch(
        getShoots(this.state.currentPage, sending, dateFilter.id)
      )
    }
    this.setState({
      isLoading: false,
    })
  }

  loadMoreShoots = () => {
    // ShootsList Load More Call
    this.setState({ currentPage: this.state.currentPage + 1 })
  }
  sortShoots = shoots => {
    return shoots
  }
  filterShoots = shoots => {
    return shoots
  }

  searchFilter = shoots => {
    return shoots
  }

  dateFilter = shoots => {
    return shoots
  }

  creatorFilter = shoots => {
    return shoots
  }

  setSortFilter = (sortOption, direction) => {
    // Resetting Page for Shoots By Date/Name
    if (this.props.shoots && this.props.shoots.length) {
      if (
        this.state.isCalendarView === true ||
        this.state.isListView === true
      ) {
        this.setState({ sort: null })
      } else {
        this.setState({ currentPage: 1 })
      }
    }
    if (direction) {
      this.setState({ sort: { ...sortOption, dir: !direction } })
    } else {
      this.setState({ sort: sortOption })
    }

    let dateFilter = {}

    if (!isNil(sortOption)) {
      localStorage.setItem(
        "shootsSort",
        JSON.stringify({ id: sortOption.id, dir: !direction })
      )
    } else {
      localStorage.removeItem("shootsSort")
    }
    ////// SORT SHOOTS BY CLICK \\\\\\\
    if (this.props.shoots && this.props.shoots.length) {
      // setTimeout(() => {
      let sending = {}
      let filter = []
      let sort = this.state.sort
      const activeCompany = this.props.activeCompany
      let creatorName = this.state.creatorFilters
      sending.creatorFilter = creatorName
      let searchKey = this.state.search
      sending.searchKey = searchKey
      sending.sort = sort
      sending.activeCompany = activeCompany
      sending.and = this.state.and
      if (this.state.dateFilter != null) {
        dateFilter = this.state.dateFilter
        sending.id = dateFilter.id
        sending.dateFiltername = dateFilter.name
        if (
          dateFilter.name === "Specific Range" &&
          this.state.startDate != null &&
          this.state.endDate != null
        ) {
          sending.startDate = this.state.startDate
          sending.endDate = this.state.endDate
        } else {
          sending.startDate = null
          sending.endDate = null
        }
      } else {
        dateFilter.id = 1
      }
      if (this.state.filters != null) {
        filter = this.state.filters
        sending.filter = filter
      } else {
        filter = null
        sending.filter = filter
      }
      this.props.dispatch(clearShoots())

      this.props.dispatch(
        getShoots(this.state.currentPage, sending, dateFilter.id)
      )
    }
  }

  setDateFilter = dateOption => {
    if (this.props.shoots && this.props.shoots.length) {
      if (
        this.state.isCalendarView === true ||
        this.state.isListView === true
      ) {
      } else {
        this.setState({ currentPage: 1 })
      }
    }

    if (!isNil(dateOption)) {
      localStorage.setItem(
        "shootsDateFilter",
        JSON.stringify({ id: dateOption.id })
      )
      this.setState({ dateFilter: dateOption })
    } else {
      localStorage.removeItem("shootsDateFilter")
    }

    let dateFilter = {}
    if (this.props.shoots && this.props.shoots.length) {
      let sending = {}
      let filter = []
      let sort = this.state.sort
      sending.sort = sort
      let searchKey = this.state.search
      let creatorName = this.state.creatorFilters
      sending.creatorFilter = creatorName
      sending.searchKey = searchKey
      const activeCompany = this.props.activeCompany
      sending.activeCompany = activeCompany
      sending.and = this.state.and
      if (this.state.dateFilter != null) {
        dateFilter = this.state.dateFilter
        sending.id = dateFilter.id
        sending.dateFiltername = dateFilter.name
        if (
          dateFilter.name === "Specific Range" &&
          this.state.startDate != null &&
          this.state.endDate != null
        ) {
          sending.id = dateFilter.id
          sending.startDate = this.state.startDate
          sending.endDate = this.state.endDate
          localStorage.setItem("startDate", this.state.startDate)
          localStorage.setItem("endDate", this.state.endDate)
        } else {
          localStorage.removeItem("startDate")
          localStorage.removeItem("endDate")
          this.setState({ startDate: null })
          this.setState({ endDate: null })

          sending.startDate = null
          sending.endDate = null
        }
      } else {
        dateFilter.id = 1
      }
      if (this.state.filters != null) {
        filter = this.state.filters
        sending.filter = filter
      } else {
        filter = null
        sending.filter = filter
      }

      this.props.dispatch(clearShoots())

      this.props.dispatch(
        getShoots(this.state.currentPage, sending, dateFilter.id)
      )
    }
  }

  toggleShootDialog = bool => {
    this.props.dispatch(toggleShootDialog({ open: bool }))
  }

  toggleFilterDialog = bool => {
    this.setState({ showDialog: bool })
  }

  toggleCreatorFilterDialog = bool => {
    this.setState({ showCreatorFilterDialog: bool })
  }

  toggleFilterPreferencesDialog = bool => {
    this.setState({ showFilterPreferencesDialog: bool })
  }

  toggleCalendarView = () => {
    let title = ""
    let calendarApi = this.fullCalendar.current.getApi()

    let viewType = calendarApi.view.type

    this.setState({ currentPage: 1 })

    if (this.state.isCalendarView === true) {
      if (viewType === "listDay") {
        calendarApi.changeView("dayGridDay")
        localStorage.setItem("calendarDefaultView", "dayGridDay")
      } else if (viewType === "listWeek") {
        calendarApi.changeView("dayGridWeek")
        localStorage.setItem("calendarDefaultView", "dayGridWeek")
      } else if (viewType === "listMonth") {
        calendarApi.changeView("dayGridMonth")
        localStorage.setItem("calendarDefaultView", "dayGridMonth")
      } else {
        calendarApi.changeView(viewType)
        localStorage.setItem("calendarDefaultView", viewType)
      }
    }

    if (this.state.isListView === true) {
      if (viewType === "dayGridDay") {
        calendarApi.changeView("listDay")
        localStorage.setItem("calendarDefaultView", "listDay")
      } else if (viewType === "dayGridWeek") {
        calendarApi.changeView("listWeek")
        localStorage.setItem("calendarDefaultView", "listWeek")
      } else if (viewType === "dayGridMonth") {
        calendarApi.changeView("listMonth")
        localStorage.setItem("calendarDefaultView", "listMonth")
      } else {
        calendarApi.changeView(viewType)
        localStorage.setItem("calendarDefaultView", viewType)
      }
    }
  }

  toggleDateOptions = async (option, type, value) => {
    if (option !== "Cards") {
      let calendarApi = this.fullCalendar.current.getApi()
      const { isCalendarView, isListView } = this.state

      if (type === "controls") {
        if (value === "Prev") {
          calendarApi.prev()
        } else {
          calendarApi.next()
        }
      } else if (
        type !== "controls" &&
        (value === "today" || value === "Day")
      ) {
        let currentDate = calendarApi.getDate()
        if (value === "today") {
          calendarApi.today()
        } else {
          calendarApi.gotoDate(currentDate)
          if (isCalendarView === true) {
            calendarApi.changeView("dayGridDay")
            localStorage.setItem("calendarDefaultView", "dayGridDay")
          }
          if (isListView === true) {
            calendarApi.changeView("listDay")
            localStorage.setItem("calendarDefaultView", "listDay")
          }
          this.setState({
            defaultDateOption: { value: 2, label: "Day" },
          })
        }
      } else {
        if (isCalendarView === true) {
          if (value === "Week") {
            calendarApi.changeView("dayGridWeek")
            localStorage.setItem("calendarDefaultView", "dayGridWeek")
            this.setState({
              defaultDateOption: { value: 1, label: "Week" },
            })
          } else if (value === "Day") {
            calendarApi.changeView("dayGridDay")
            localStorage.setItem("calendarDefaultView", "dayGridDay")
            this.setState({
              defaultDateOption: { value: 2, label: "Day" },
            })
          } else {
            calendarApi.changeView("dayGridMonth")
            localStorage.setItem("calendarDefaultView", "dayGridMonth")
            this.setState({
              defaultDateOption: { value: 3, label: "Month" },
            })
          }
        }

        if (isListView === true) {
          if (value === "Week") {
            calendarApi.changeView("listWeek")
            localStorage.setItem("calendarDefaultView", "listWeek")
            this.setState({
              defaultDateOption: { value: 1, label: "Week" },
            })
          } else if (value === "Day") {
            calendarApi.changeView("listDay")
            localStorage.setItem("calendarDefaultView", "listDay")
            this.setState({
              defaultDateOption: { value: 2, label: "Day" },
            })
          } else {
            calendarApi.changeView("listMonth")
            localStorage.setItem("calendarDefaultView", "listMonth")
            this.setState({
              defaultDateOption: { value: 3, label: "Month" },
            })
          }
        }
      }
    } else {
      const { defaultDateOption, cardStartDate, cardEndDate } = this.state
      let startDate,
        endDate,
        title = ""
      let defaultOption = null

      if (type === "date" && (value === "today" || value === "Day")) {
        startDate = moment().set({
          hour: 0,
          minute: 0,
          second: 0,
          millisecond: 0,
        })
        endDate = moment().set({
          hour: 0,
          minute: 0,
          second: 0,
          millisecond: 0,
        })

        title = `${moment().format("DD, MMM YYYY")}`
        defaultOption = { value: 2, label: "Day" }
      }

      if (type === "date" && value === "Week") {
        startDate = moment()
          .subtract(1, "weeks")
          .startOf("isoWeek")
          .set({
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0,
          })
        endDate = moment()
          .subtract(1, "weeks")
          .endOf("isoWeek")
          .set({
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0,
          })

        title = `${moment(startDate).format("MMM DD")} - 
        ${moment(endDate).format("MMM DD")} , 
        ${moment(startDate).format("YYYY")}`
        defaultOption = { value: 1, label: "Week" }
      }

      if (type === "date" && value === "Month") {
        startDate = moment()
          .startOf("month")
          .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
        endDate = moment()
          .endOf("month")
          .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })

        title = `${moment()
          .startOf("month")
          .format("MMM YYYY")}`

        defaultOption = { value: 3, label: "Month" }
      }

      if (type === "controls") {
        if (value === "Next") {
          if (defaultDateOption.label === "Month") {
            startDate = moment(cardStartDate)
              .add(1, "months")
              .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
            endDate = moment(startDate)
              .endOf("month")
              .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
            title = `${moment(startDate)
              .startOf("month")
              .format("MMM YYYY")}`
          } else if (defaultDateOption.label === "Week") {
            startDate = moment(cardStartDate)
              .add(1, "week")
              .startOf("isoWeek")
              .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
            endDate = moment(startDate)
              .endOf("isoWeek")
              .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })

            title = `${moment(startDate).format("MMM DD")} - 
              ${moment(endDate).format("MMM DD")} , 
              ${moment(startDate).format("YYYY")}`
          } else {
            startDate = moment(cardStartDate)
              .add(1, "days")
              .set({
                hour: 0,
                minute: 0,
                second: 0,
                millisecond: 0,
              })
            endDate = moment(startDate)
              .add(1, "days")
              .set({
                hour: 0,
                minute: 0,
                second: 0,
                millisecond: 0,
              })

            title = `${moment(startDate).format("DD, MMM YYYY")}`
          }
        } else {
          if (defaultDateOption.label === "Month") {
            startDate = moment(cardStartDate)
              .subtract(1, "months")
              .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
            endDate = moment(startDate)
              .endOf("month")
              .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
            title = `${moment(startDate)
              .startOf("month")
              .format("MMM YYYY")}`
          } else if (defaultDateOption.label === "Week") {
            startDate = moment(cardStartDate)
              .subtract(1, "week")
              .startOf("isoWeek")
              .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
            endDate = moment(startDate)
              .endOf("isoWeek")
              .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })

            title = `${moment(startDate).format("MMM DD")} - 
              ${moment(endDate).format("MMM DD")} , 
              ${moment(startDate).format("YYYY")}`
          } else {
            startDate = moment(cardStartDate)
              .subtract(1, "days")
              .set({
                hour: 0,
                minute: 0,
                second: 0,
                millisecond: 0,
              })
            endDate = moment(startDate)
              .subtract(1, "days")
              .set({
                hour: 0,
                minute: 0,
                second: 0,
                millisecond: 0,
              })

            title = `${moment(startDate).format("DD, MMM YYYY")}`
          }
        }
      }

      this.setState({
        dateShowTitle: title,
        cardStartDate: startDate,
        cardEndDate: endDate,
        defaultDateOption: defaultOption
          ? defaultOption
          : this.state.defaultDateOption,
        crewShoots: [],
      })

      await this.getDatedShoots(startDate, endDate)
    }
  }

  getDatedShoots = (startDate, endDate) => {
    const { creatorFilters } = this.state

    this.setState({
      isLoading: true,
    })
    let sending = {}
    // set activecompany for crewmama
    const activeCompany = this.props.activeCompany || 2

    sending.creatorFilter = creatorFilters
    sending.searchKey = ""
    sending.activeCompany = activeCompany

    sending.startDate = startDate.format()
    sending.endDate = endDate.format()

    sending.filter = []

    this.props.dispatch(shootsByCrew(sending)).then(res => {
      this.setState({ crewShoots: res })
    })
    this.setState({ flag: 0, isLoading: false })
  }

  toggleViewOption = async (option, type, value) => {
    let defaultView = null
    if (value === "Cards") {
      defaultView = { value: 1, label: "Cards" }
      await this.setState({ isCalendarView: false, isListView: false })
    } else if (value === "Calendar") {
      // toggleOptions.option = value
      // toggleOptions.type = value
      // toggleOptions.value = this.state.defaultDateOption.label
      defaultView = { value: 2, label: "Calendar" }
      await this.setState({ isCalendarView: true, isListView: false })
    } else {
      // toggleOptions.option = value
      // toggleOptions.type = value
      // toggleOptions.value = this.state.defaultDateOption.label
      defaultView = { value: 3, label: "List" }
      await this.setState({ isCalendarView: false, isListView: true })
    }

    await this.setState({ defaultViewOption: defaultView })
    if (value !== "Cards") {
      await this.toggleCalendarView()
    }
  }

  //new cases method

  //case calendarApi // case not calendarApi

  goToShoot = shootId => {
    if (this.props.activeCompany) {
      this.props.history.push("/shoots/" + shootId)
    } else {
      this.props.history.push("/my-shoots/" + shootId)
    }
  }

  // new open modal logix
  eventClick = ({ event, jsEvent }) => {
    // NEED TO ADD MOBILE DROPDOWN LOGIC
    if (isMobile && this.state.isListView && !this.state.isCalendarView) {
      const rect = jsEvent.target.getBoundingClientRect()
      this.setState({
        eventPopoverEl: jsEvent.target,
        eventPopoverShoot: event.extendedProps.shootDetails,
        eventPopoverPosition: { top: jsEvent.pageY },
      })
    } else {
      this.props.dispatch(toggleEditShootDialog(true))

      event.extendedProps.shootDetails.roles &&
        !isEmpty(event.extendedProps.shootDetails.roles) &&
        event.extendedProps.shootDetails.roles.forEach(role => {
          if (role.user_id) {
            this.props.dispatch(getCrew(role.user_id))
          }
        })
      this.props.dispatch(setEditShoot(event.extendedProps.shootDetails))
    }
  }

  openShootQuickView = shoot => {
    this.props.dispatch(toggleEditShootDialog(true))

    shoot.roles &&
      !isEmpty(shoot.roles) &&
      shoot.roles.forEach(role => {
        if (role.user_id) {
          this.props.dispatch(getCrew(role.user_id))
        }
      })
    this.props.dispatch(setEditShoot(shoot))
  }

  updateShootStatus = shootId => {
    const { shoots } = this.props
    const updatedShoot = find(shoots, s => s.id === shootId)
    updatedShoot.roles &&
      !isEmpty(updatedShoot.roles) &&
      updatedShoot.roles.forEach(role => {
        if (role.user_id) {
          this.props.dispatch(getCrew(role.user_id))
        }
      })
    this.props.dispatch(setEditShoot(updatedShoot))
  }

  openSearchedShoot = shootId => {
    this.props.dispatch(toggleEditShootDialog(true))
    this.props.dispatch(getShootbyId(shootId)).then(res => {
      if (res && res.length > 0) {
        res[0].roles &&
          !isEmpty(res[0].roles) &&
          res[0].roles.forEach(role => {
            if (role.user_id) {
              this.props.dispatch(getCrew(role.user_id))
            }
          })
        this.props.dispatch(setEditShoot(res[0]))
      }
    })
  }

  eventMouseLeave = () => {
    this.setState({ eventPopoverEl: null })
    setTimeout(() => {
      this.setState({ eventPopoverShoot: null })
    }, 300)
  }

  getEventPopoverContainer = () => {
    if (this.state.eventPopoverEl) {
      return this.state.eventPopoverEl.getElementByClassName("fc-day")
    } else {
      return document.body
    }
  }
  onClickPop = info => {
    // debugger;
    if (this.props.activeCompany) {
      this.props.history.push("/shoots/" + info.event.id)
    } else {
      this.props.history.push("/shoots/" + info.event.id + "/details")
    }
  }
  eventRender = ({ event }) => {
    if (
      localStorage.getItem("calendarDefaultView") === "dayGridWeek" ||
      localStorage.getItem("calendarDefaultView") === "dayGridDay" ||
      localStorage.getItem("calendarDefaultView") === "dayGridMonth"
    ) {
      const mainDiv = document.createElement("div")

      if (event.extendedProps.shootDetails.firm === 1) {
        mainDiv.className = this.props.classes.firm
      } else {
        mainDiv.className = this.props.classes.standBy
      }

      const statusIndicator = document.createElement("div")
      statusIndicator.Id = "statusInd"
      const title = document.createElement("div")

      title.classList.add("fc-event-title", this.props.classes.eventText)
      title.append(event.extendedProps.shootDetails.name)

      // set initial className
      statusIndicator.className = this.props.classes.statusIndicator
      // add a class to classList for the status
      statusIndicator.classList.add(
        this.props.classes[
          `${event.extendedProps.shootDetails.status}Indicator`
        ]
      )

      mainDiv.append(statusIndicator)
      mainDiv.append(title)
      $(".fc-event-title .fc-sticky").after(mainDiv)

      let arrayOfDomNodes = [mainDiv]
      return { domNodes: arrayOfDomNodes }
    }
    if (
      localStorage.getItem("calendarDefaultView") === "listWeek" ||
      localStorage.getItem("calendarDefaultView") === "listDay" ||
      localStorage.getItem("calendarDefaultView") === "listMonth"
    ) {
      const dayheading = document.getElementsByClassName("fc-list-day-cushion")
      dayheading.className = this.props.classes.listViewHeading

      const table = document.createElement("table")

      // table.className = "fc-list-table"
      const tbody = document.createElement("tbody")

      const row = document.createElement("tr")
      // row.className = "fc-list-event fc-event fc-event-end fc-event-past"

      const title = document.createElement("td")
      title.className = this.props.classes.listViewTitle
      title.append(event.extendedProps.shootDetails.name)

      if (isMobile) {
        const collapse = document.createElement("i")
        collapse.className = "material-icons"
        let arrowDropDownClass = "arrow_drop_down"
        collapse.append(arrowDropDownClass)

        row.append(title)
        row.append(collapse)
        tbody.append(row)
      } else {
        const location = document.createElement("td")
        location.className = this.props.classes.listViewLocation
        let abbr = convertToAbbr(
          event.extendedProps.shootDetails.location.state
        )
        let selectedAbbr = ""
        if (abbr[0] && abbr[0].abbr) {
          selectedAbbr = abbr[0].abbr
        }
        let combinedCityState =
          event.extendedProps.shootDetails.location.city + ", " + selectedAbbr

        location.append(combinedCityState)

        const status = document.createElement("td")
        status.className = this.props.classes.listViewStatus
        let statusCode = event.extendedProps.shootDetails.firm === 1 ? "F" : "S"
        status.append(statusCode)

        let crewImgColumn = document.createElement("td")
        crewImgColumn.className = this.props.classes.listViewStatus
        let crewImages
        event.extendedProps.shootDetails.users &&
          !isEmpty(event.extendedProps.shootDetails.users) &&
          event.extendedProps.shootDetails.users.map(
            (user, index) => (
              (crewImages = document.createElement("img")),
              (crewImages.src = !isEmpty(user.profile_image)
                ? `https://res.cloudinary.com/adesk/image/upload/c_thumb,g_face:auto,z_0.7,h_170,w_300,fl_lossy,f_auto/v${
                    JSON.parse(user.profile_image).version
                  }/${JSON.parse(user.profile_image).public_id}.${
                    JSON.parse(user.profile_image).format
                  }`
                : Image),
              (crewImages.alt = ""),
              (crewImages.className = this.props.classes.avatar),
              crewImgColumn.append(crewImages)
            )
          )

        const creator = document.createElement("td")
        creator.className = this.props.classes.listViewStatus

        if (
          !isEmpty(event.extendedProps.shootDetails.creator) &&
          head(event.extendedProps.shootDetails.creator)
        ) {
          creator.append(
            head(event.extendedProps.shootDetails.creator).first_name +
              " " +
              head(event.extendedProps.shootDetails.creator).last_name
          )
        } else {
          creator.append("N/A")
        }

        row.append(title)
        row.append(location)
        row.append(status)
        row.append(crewImgColumn)
        row.append(creator)
      }

      tbody.append(row)
      table.append(tbody)
      $(".fc-widget-header").after(table)
      let arrayOfDomNodes = [table]
      return { domNodes: arrayOfDomNodes }
    }
  }

  onClearCreatorFilter = () => {
    localStorage.removeItem("shootsCreatorFilters")

    if (!isEmpty(this.state.creatorFilters)) {
      this.setState({ creatorFilters: [] }, () => {
        this.onChangeCreatorFilter(this.state.creatorFilters)
      })
    }
  }

  onChangeCreatorFilter = creatorFilter => {
    this.setState({
      isLoading: true,
    })
    if (this.props.shoots && this.props.shoots.length) {
      if (this.state.isCalendarView === true) {
      } else {
        this.setState({ currentPage: 1 })
      }
      let sending = {}
      let filter = []
      let dateFilter = {}
      let searchKey = this.state.search

      let sort = this.state.sort
      const activeCompany = this.props.activeCompany
      let creatorName = creatorFilter
      sending.creatorFilter = creatorName
      sending.sort = sort
      sending.activeCompany = activeCompany
      sending.searchKey = searchKey
      sending.and = this.state.and

      if (this.state.dateFilter != null) {
        dateFilter = this.state.dateFilter
        dateFilter = this.state.dateFilter
        sending.id = dateFilter.id
        sending.dateFiltername = dateFilter.name
        if (
          dateFilter.name === "Specific Range" &&
          this.state.startDate != null &&
          this.state.endDate != null
        ) {
          sending.startDate = this.state.startDate
          sending.endDate = this.state.endDate
        } else {
          sending.startDate = null
          sending.endDate = null
        }
      } else {
        dateFilter.id = 1
      }

      if (this.state.filters != null) {
        filter = this.state.filters
        sending.filter = filter
      } else {
        filter = null
        sending.filter = filter
      }
      sending.startDate = this.state.dateSetStrDate
      sending.endDate = this.state.dateSetEndDate
      this.props.dispatch(clearShoots())
      // console.log('new sending', sending)
      this.props.dispatch(getCalenderShoots(sending))
      this.setState({
        isLoading: false,
      })
    }
  }
  onChangeSearch = e => {
    this.setState({
      isLoading: true,
    })
    if (this.state.searchTimeout) {
      clearTimeout(this.state.searchTimeout)
    }

    const searchTimeout = setTimeout(() => {
      if (!this.state.isCalendarView === true) {
        this.setState({ currentPage: 1 })
      }
      let sending = {}
      let filter = []
      let searchKey = this.state.search
      localStorage.setItem("shootsSearch", searchKey)
      let dateFilter = {}
      let sort = this.state.sort
      const activeCompany = this.props.activeCompany
      let creatorName = this.state.creatorFilters
      sending.creatorFilter = creatorName
      sending.sort = sort
      sending.activeCompany = activeCompany || 2
      sending.searchKey = searchKey
      if (this.state.defaultViewOption.label === "Cards") {
        sending.startDate = this.state.cardStartDate.format()
        sending.endDate = this.state.cardEndDate.format()
      } else {
        if (
          dateFilter.name === "Specific Range" &&
          this.state.startDate != null &&
          this.state.endDate != null
        ) {
          sending.startDate = this.state.startDate
          sending.endDate = this.state.endDate
        } else {
          sending.startDate = null
          sending.endDate = null
        }
      }

      sending.filter = filter
      this.props.dispatch(clearShoots())
      this.props.dispatch(getCalenderShoots(sending))
    }, 400)
    this.setState({
      search: e.target.value,
      searchTimeout,
      isLoading: false,
    })
  }

  datesSetRange = datesSet => {
    this.setState({
      isLoading: true,
    })

    var res =
      Math.abs(new Date(datesSet.startStr) - new Date(datesSet.endStr)) / 1000
    var days = Math.floor(res / 86400)

    const startDate = moment(datesSet.startStr).subtract(30, "days")
    const endDate = moment(datesSet.endStr).add(30, "days")

    // DATE
    const dateSetStrDate = startDate.format()
    const dateSetEndDate = endDate.format()

    localStorage.setItem("dateSetStrDate", dateSetStrDate)
    localStorage.setItem("dateSetEndDate", dateSetEndDate)
    localStorage.setItem("calendarDefaultView", datesSet.view.type)
    let fullCalendarResetDate = null
    if (datesSet.view.type === "dayGridMonth") {
      const startStr = moment(datesSet.startStr)
      if (+startStr.format("DD") >= 20) {
        fullCalendarResetDate = moment({
          month: +startStr.format("MM"),
          day: 15,
          year: +startStr.format("YYYY"),
        })
      } else {
        fullCalendarResetDate = moment().set({
          month: +startStr.format("MM") - 1,
          day: 15,
        })
      }
    } else {
      fullCalendarResetDate = moment(datesSet.startStr)
    }

    fullCalendarResetDate = fullCalendarResetDate.toISOString()
    localStorage.setItem("fullCalendarResetDate", fullCalendarResetDate)
    if (
      dateSetStrDate !== this.state.dateSetStrDate &&
      dateSetEndDate !== this.state.dateSetEndDate
    ) {
      this.setState(
        {
          dateSetStrDate: dateSetStrDate,
          dateSetEndDate: dateSetEndDate,
        },
        () => {
          let sending = {}
          let filter = []
          let searchKey = this.state.search
          // need to change active company from static to crewmama company
          const activeCompany = 2
          let creatorName = this.state.creatorFilters
          sending.creatorFilter = creatorName

          sending.activeCompany = activeCompany
          sending.searchKey = searchKey
          sending.startDate = dateSetStrDate
          sending.endDate = dateSetEndDate
          sending.and = this.state.and

          sending.filter = filter

          this.props.dispatch(getCalenderShoots(sending))
        }
      )
    }

    let title = ""

    if (
      localStorage.getItem("calendarDefaultView") === "dayGridWeek" ||
      localStorage.getItem("calendarDefaultView") === "listWeek"
    ) {
      title = `${moment(datesSet.startStr).format("MMM DD")} - 
        ${moment(datesSet.endStr).format("MMM DD")} , 
        ${moment(datesSet.startStr).format("YYYY")}`
      this.setState({
        defaultDateOption: { value: 1, label: "Week" },
      })
    } else if (
      localStorage.getItem("calendarDefaultView") === "dayGridDay" ||
      localStorage.getItem("calendarDefaultView") === "listDay"
    ) {
      title = `${moment(datesSet.startStr).format("MMM DD, YYYY")}`
      this.setState({
        defaultDateOption: { value: 2, label: "Day" },
      })
    } else {
      if (localStorage.getItem("calendarDefaultView") === "listMonth") {
        title = `${moment(fullCalendarResetDate).format("MMM YYYY")}`
      }
      if (localStorage.getItem("calendarDefaultView") === "dayGridMonth") {
        title = `${moment(datesSet.startStr)
          .add(15, "days")
          .format("MMM YYYY")}`
      }

      this.setState({
        defaultDateOption: { value: 3, label: "Month" },
      })
    }

    this.setState({
      dateShowTitle: title,
      isLoading: false,
    })
  }

  createDefaultFilters = (data, bool) => {
    this.setState({ saving: true, isLoading: true })
    const filterParams = {
      company_id: this.props.activeCompany,
      filters: data,
      startDate: localStorage.getItem("dateSetStrDate"),
      endDate: localStorage.getItem("dateSetEndDate"),
    }
    this.props
      .dispatch(
        saveDefaultFilters(
          filterParams,
          this.props.authentication.authenticatedUser.id
        )
      )
      .then(async () => {
        this.props.dispatch(openSnackBar({ message: "default filters saved" }))
        if (bool) {
          localStorage.setItem("defaultFiltersSwitch", bool)
          await this.setState({
            defaultFiltersSwitch: bool,
          })
          await this.applyDefaultFilters()
        }
        this.setState({ saving: false, isLoading: false })
      })
      .catch(error => {
        this.props.dispatch(
          openSnackBar({
            message: "Something is wrong, default filters are not saved",
          })
        )
      })

    this.setState({ saving: false, isLoading: false })
  }

  toggleDefaultFilters = async bool => {
    localStorage.setItem("defaultFiltersSwitch", bool)
    await this.setState({
      defaultFiltersSwitch: bool,
    })
    if (bool) {
      this.applyDefaultFilters()
    } else {
      localStorage.removeItem("shootsCreatorFilters")
      localStorage.removeItem("shootsFilters")
      this.setState(
        {
          filters: [],
          creatorFilters: [],
        },
        () => {
          this.setFilter([])
        }
      )
    }
  }

  toggleViewDefaultFilters = async bool => {
    localStorage.setItem("defaultFiltersSwitch", bool)
    await this.setState({
      defaultFiltersSwitch: bool,
    })
    if (bool) {
      this.applyDefaultFilters()
    } else {
      localStorage.removeItem("shootsCreatorFilters")
      localStorage.removeItem("shootsFilters")
      this.setState(
        {
          filters: [],
          creatorFilters: [],
        },
        () => {
          this.setFilter([])
        }
      )
    }
  }
  onRemoveFilters = () => {
    this.setState({ saving: true, isLoading: true })
    this.props
      .dispatch(
        removeDefaultFilters(this.props.authentication.authenticatedUser.id)
      )
      .then(() => {
        this.props.dispatch(
          openSnackBar({ message: "filters removed successfully" })
        )
        this.setState({ saving: false, isLoading: false })
      })
      .catch(error => {
        this.props.dispatch(
          openSnackBar({
            message: "Something is wrong, default filters are not removed",
          })
        )
      })

    this.setState({ saving: false, isLoading: false })
  }

  render() {
    const { props, state } = this
    const {
      shoots,
      authentication,
      activeCompany,
      accessLevel,
      classes,
      editShootDialogOpen,
      confirmDuplicateShootDialogueOpen,
      defaultFilters,
    } = props
    const {
      filters,
      and,
      popover,
      eventPopoverEl,
      eventPopoverPosition,
      eventPopoverShoot,
      currentPage,
      isLoading,
      isLoadingShoots,
      dateShowTitle,
      dateOptions,
      defaultDateOption,
      toggleFilterSwitch,
      defaultViewOption,
    } = state

    const composedShoots = compose(
      this.filterShoots,
      this.dateFilter,
      this.searchFilter,
      this.creatorFilter,
      this.sortShoots
    )(
      shoots.concat(
        this.state.crewShoots.filter(
          x => shoots.findIndex(y => y.id === x.id) === -1
        )
      )
    )

    const calendarShoots = composedShoots.map(shoot => {
      const start = new Date(shoot.start_date).toISOString()
      const end = new Date(shoot.end_date).toISOString()
      const addDay = start !== end
      const color = shoot.firm ? green[400] : "#FFB60C"
      return {
        id: shoot.id,
        title: shoot.name,
        start,
        end: addDay ? addDays(new Date(shoot.end_date), 1).toISOString() : end,
        allDay: true,
        shootDetails: shoot,
        backgroundColor: color,
        borderColor: color,
      }
    })

    const sortedArr = orderBy(composedShoots, "start_date", "desc")

    const cardShoots = sortedArr.slice(0, (currentPage + 1) * shootsPerPage)

    // eventPopoverEl open prop
    const eventPopoverOpen = Boolean(eventPopoverEl)
    return (
      <Fragment>
        <LoadingOverlay
          active={this.state.saving || isLoadingShoots}
          spinner
          text="Loading Data..."
          styles={{
            wrapper: {},
          }}
        >
          {getCurrentHost() === "crewmama" ? (
            <CrewMamaAppBarComponent history={this.props.history} />
          ) : (
            <Fragment>
              <MainAppBar />
              <TabBar history={this.props.history} />
            </Fragment>
          )}

          {/* CALENDAR TOOLBAR */}
          {!isLoading && (
            <CalendarHeaderToolbar
              dateShowRange={dateShowTitle}
              handleToolbarControls={(option, type, value) =>
                this.toggleDateOptions(option, type, value)
              }
              searchOnChange={this.onChangeSearch}
              handleViewChange={(option, type, value) =>
                this.toggleViewOption(option, type, value)
              }
              viewOptions={this.state.viewOptions}
              dateOptions={dateOptions}
              defaultDateOption={defaultDateOption}
              defaultFiltersSwitch={this.state.defaultFiltersSwitch}
              onToggleHideFilters={bool => this.toggleHideFilters(bool)}
              onToggleDefaultFilters={bool => this.toggleDefaultFilters(bool)}
              defaultFilters={defaultFilters}
              toggleShootDialog={this.toggleShootDialog}
              toggleFilterSwitch={toggleFilterSwitch}
              defaultViewOption={defaultViewOption}
              search={state.search}
            />
          )}

          <section className={this.props.classes.shootsSection}>
            <div
              className={this.props.classes.shootsSectionWrapper}
              ref={divElement => {
                this.divElement = divElement
              }}
            >
              {isLoading && (
                <div className={this.props.classes.loaderSectionWrapper}>
                  <CircularProgress style={{ margin: "100px" }} />
                </div>
              )}
              {defaultViewOption.label === "Cards" && (
                <div>
                  <InfiniteScroll
                    dataLength={cardShoots.length} //This is important field to render the next data
                    next={this.loadMoreShoots}
                    hasMore={calendarShoots.length > cardShoots.length}
                    loader={<h4>Loading...</h4>}
                  >
                    <div className={this.props.classes.shootCardContainer}>
                      {cardShoots.map(shoot => {
                        return (
                          <div
                            key={shoot.id}
                            className={this.props.classes.shootCardWrapper}
                          >
                            <ShootCard
                              shoot={shoot}
                              setState={e => this.setState(e)}
                            />
                          </div>
                        )
                      })}
                    </div>
                  </InfiniteScroll>
                </div>
              )}

              {(defaultViewOption.label === "Calendar" ||
                defaultViewOption.label === "List") &&
                !isLoading && (
                  <div style={{ width: "100%" }}>
                    <FullCalendar
                      ref={this.fullCalendar}
                      initialView={
                        localStorage.getItem("calendarDefaultView") ||
                        "listWeek"
                      }
                      plugins={[listPlugin, dayGridPlugin]}
                      events={calendarShoots}
                      eventClick={this.eventClick}
                      eventContent={this.eventRender}
                      headerToolbar={{ left: "", right: "", center: "" }}
                      datesSet={this.datesSetRange}
                      height="auto"
                      dayHeaderClassNames={[classes.dayHeaderFix]}
                      dayCellClassNames={[classes.dayCellFix]}
                      initialDate={
                        localStorage.getItem("fullCalendarResetDate") &&
                        isDate(localStorage.getItem("fullCalendarResetDate"))
                          ? localStorage.getItem("fullCalendarResetDate")
                          : new Date()
                      }
                      weekends
                      allDaySlot="false"
                      eventBorderColor="none"
                    />
                    <div
                      className={classes.popoverBlurDiv}
                      onClick={this.eventMouseLeave}
                      style={{ display: eventPopoverOpen ? "block" : "none" }}
                    />
                    <div
                      className={classes.customPopover}
                      style={
                        {
                          top: `calc(${eventPopoverPosition.top.toFixed(
                            0
                          )}px + 20px)`,
                          opacity: eventPopoverOpen ? 1 : 0,
                        } // left: `${eventPopoverPosition.left.toFixed(0)}px`,
                      }
                    >
                      {/* // onClick={this.goToShoot} */}
                      {eventPopoverShoot && (
                        <Fragment>
                          <Box
                            component="div"
                            m={1}
                            className={classes.shootPopoverRow}
                          >
                            <Typography variant="p">Location</Typography>
                            <Typography variant="p">
                              {eventPopoverShoot.location
                                ? eventPopoverShoot.location.city +
                                  ", " +
                                  eventPopoverShoot.location.state
                                : "TBD"}
                            </Typography>
                          </Box>
                          <Box
                            component="div"
                            m={1}
                            className={classes.shootPopoverRow}
                          >
                            <Typography variant="p">Type</Typography>
                            <Typography variant="p">
                              {eventPopoverShoot.firm === 1 ? "F" : "S"}
                            </Typography>
                          </Box>
                          {eventPopoverShoot.users &&
                            !isEmpty(eventPopoverShoot.users) && (
                              <Box
                                component="div"
                                m={1}
                                className={classes.shootPopoverRow}
                                style={{ alignItems: "center" }}
                              >
                                <Typography variant="p">Crew</Typography>
                                <Box
                                  component="div"
                                  style={{ display: "flex" }}
                                >
                                  {eventPopoverShoot.users.map(
                                    (user, index) => (
                                      <Avatar
                                        key={index}
                                        src={
                                          !isEmpty(user.profile_image)
                                            ? `https://res.cloudinary.com/adesk/image/upload/c_thumb,g_face:auto,z_0.7,h_170,w_300,fl_lossy,f_auto/v${
                                                JSON.parse(user.profile_image)
                                                  .version
                                              }/${
                                                JSON.parse(user.profile_image)
                                                  .public_id
                                              }.${
                                                JSON.parse(user.profile_image)
                                                  .format
                                              }`
                                            : Image
                                        }
                                      />
                                    )
                                  )}
                                </Box>
                              </Box>
                            )}
                          {!isEmpty(eventPopoverShoot.creator) &&
                            head(eventPopoverShoot.creator) && (
                              <Box
                                component="div"
                                m={1}
                                className={classes.shootPopoverRow}
                              >
                                <Typography variant="p">Booked By</Typography>
                                <Typography variant="p">
                                  {head(eventPopoverShoot.creator).first_name +
                                    " " +
                                    head(eventPopoverShoot.creator).last_name}
                                </Typography>
                              </Box>
                            )}
                          <Box
                            component="div"
                            m={1}
                            className={classes.openShootDetails}
                            onClick={() =>
                              this.openShootQuickView(eventPopoverShoot)
                            }
                          >
                            <Typography
                              variant="p"
                              color="primary"
                              style={{ fontWeight: 600 }}
                            >
                              View Details
                            </Typography>
                          </Box>
                        </Fragment>
                      )}
                    </div>
                  </div>
                )}

              {calendarShoots.length === 0 && (
                <Typography variant="h6">
                  No Shoots Found. Click the "New Shoot" button to create a
                  shoot.
                </Typography>
              )}
            </div>
          </section>

          {/* START PREFERENCES DIALOG */}

          {activeCompany && (
            <FilterPreferencesDialog
              onChange={filters => {
                localStorage.setItem(
                  "shootsCreatorFilters",
                  JSON.stringify(
                    filters.map(x => {
                      return { ...x, func: undefined }
                    })
                  )
                )
                this.setState({ creatorFilters: filters }, () => {
                  this.onChangeCreatorFilter(this.state.creatorFilters)
                })
              }} // onApplyDefaultFilters = {continue from here}
              createDefaultFilters={(data, bool) =>
                this.createDefaultFilters(data, bool)
              }
              onRemove={() => this.onRemoveFilters()}
              onClose={e =>
                this.setState({
                  showFilterPreferencesDialog: false,
                })
              }
              open={this.state.showFilterPreferencesDialog}
              filters={
                defaultFilters
                  ? JSON.parse(defaultFilters.filters).statusOptions
                  : []
              }
              creators={
                authentication.authenticatedUser.companies.find(
                  x => x.id === activeCompany
                )
                  ? authentication.authenticatedUser.companies.find(
                      x => x.id === activeCompany
                    ).managers
                  : []
              }
              and={and}
              creatorFilters={
                defaultFilters
                  ? JSON.parse(defaultFilters.filters).creatorsOptions.map(
                      x => x.name
                    )
                  : []
              }
              calendarOption={
                defaultFilters
                  ? JSON.parse(defaultFilters.filters).calendarOption
                  : null
              }
              calendarViewOption={
                defaultFilters
                  ? JSON.parse(defaultFilters.filters).calendarViewOption
                  : null
              }
              defaultFilters={defaultFilters}
            />
          )}

          {/* END PREFERENCES DIALOG */}

          {/* FILTER DIALOG */}
          <FilterDialog
            setFilter={this.setFilter}
            onChange={(filters, and) => {
              const existingFilters = state.filters
              const filtersToRemove = existingFilters.filter(
                x => !includes(filters, x)
              )
              const updatedFilterState = [...state.filters, ...filters].filter(
                x => !includes(filtersToRemove, x)
              )

              if (uniq(updatedFilterState).length > 0) {
                localStorage.setItem(
                  "shootsFilters",
                  JSON.stringify({
                    filters: uniq(updatedFilterState).map(x => x.id),
                    and,
                  })
                )
              }
              // else {
              //   localStorage.removeItem("shootsFilter")
              // }
              this.setState({ and, filters: uniq(updatedFilterState) })
              // , () => {
              //   this.onChangeCreatorFilter(this.state.filters)
              // })
            }}
            onClose={e =>
              this.setState({
                showDialog: false,
              })
            }
            open={this.state.showDialog}
            filters={filters}
            and={and}
          />

          {/* {activeCompany && (
            <CreatorFilterDialog
              onChange={filters => {
                localStorage.setItem(
                  "shootsCreatorFilters",
                  JSON.stringify(
                    filters.map(x => {
                      return { ...x, func: undefined }
                    })
                  )
                )
                this.setState({ creatorFilters: filters }, () => {
                  this.onChangeCreatorFilter(this.state.creatorFilters)
                })
              }}
              onClear={this.onClearCreatorFilter}
              onClose={e =>
                this.setState({
                  showCreatorFilterDialog: false,
                })
              }
              open={this.state.showCreatorFilterDialog}
              filters={filters}
              creators={
                authentication.authenticatedUser.companies.find(
                  x => x.id === activeCompany
                )
                  ? authentication.authenticatedUser.companies.find(
                      x => x.id === activeCompany
                    ).managers
                  : []
              }
              and={and}
              creatorFilters={this.state.creatorFilters.map(x => x.name)}
            />
          )} */}
          <Popover
            id={"areYouSure"}
            open={Boolean(popover.anchor)}
            anchorEl={popover.anchor}
            onClose={e => {
              popover.func(false)
              this.setState({ popover: { anchor: null, func: () => "" } })
            }}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            transformOrigin={{ vertical: "bottom", horizontal: "center" }}
          >
            <div style={{ textAlign: "center" }}>
              <Typography style={{ margin: "8px" }}>Are You Sure?</Typography>
              <div style={{ display: "flex" }}>
                <Button
                  onClick={e => {
                    popover.func(false)
                    this.setState({
                      popover: {
                        anchor: null,
                        func: () => "",
                      },
                    })
                  }}
                >
                  No
                </Button>
                <Button
                  onClick={e => {
                    popover.func(true)
                    this.setState({
                      popover: {
                        anchor: null,
                        func: () => "",
                      },
                    })
                  }}
                  color="primary"
                >
                  Yes
                </Button>
              </div>
            </div>
          </Popover>
          {/* CALENDAR EVENT POPOVER ELEMENT */}
          {/* <Popover
          open={eventPopoverOpen}
          anchorEl={eventPopoverEl}
          // className={classes.eventPopover}
          // classes={{
          //   paper: classes.eventPopoverPaper,
          // }}
          // anchorOrigin={{
          //   vertical: "bottom",
          //   horizontal: "left",
          // }}
          // transformOrigin={{
          //   vertical: "top",
          //   horizontal: "left",
          // }}
          onClose={this.eventMouseLeave}
          // disableRestoreFocus
        >
          <span
            onClick={() => {
              this.onClickPop
            }}
            className={classes.paper}
          >
            The content of the Popper.
          </span>
          {/* {eventPopoverShoot && (
            <Fragment>
              <Typography variant="h6" className={classes.eventPopoverTitle}>
                {eventPopoverShoot.name}
              </Typography>
              <div className={classes.placeWrapper}>
                <PlaceIcon className={classes.placeIcon} />
                <Typography
                  variant="caption"
                  className={classes.placeName}
                  color="inherit"
                >
                  {eventPopoverShoot.location
                    ? eventPopoverShoot.location.city +
                      ", " +
                      eventPopoverShoot.location.state
                    : "TBD"}
                </Typography>
              </div>
              {eventPopoverShoot.roles.map(x => {
                return (
                  <div
                    className={classes.roleTitle}
                    key={x.id + ":" + x.user_id}
                  >
                    {x.name +
                      (x.user_id &&
                      this.props.users.length > 1 &&
                      this.props.users.findIndex(y => y.id === x.user_id) !== -1
                        ? `: ${
                            this.props.users.find(y => y.id === x.user_id)
                              .full_name
                          }`
                        : "")}
                  </div>
                )
              })}
            </Fragment>
          )}
        </Popover> */}
          <Hidden smDown>
            {!isEmpty(this.props.shoot) &&
              editShootDialogOpen && (
                <div>
                  <EditShootDialog
                    onUpdateShootStatus={shootId =>
                      this.updateShootStatus(shootId)
                    }
                    onClickEdit={shootId => this.goToShoot(shootId)}
                    fullScreen={false}
                  />
                </div>
              )}
          </Hidden>

          <Hidden mdUp>
            {!isEmpty(this.props.shoot) &&
              editShootDialogOpen && (
                <div>
                  <EditShootDialog
                    onUpdateShootStatus={shootId =>
                      this.updateShootStatus(shootId)
                    }
                    onClickEdit={shootId => this.goToShoot(shootId)}
                    fullScreen={true}
                  />
                </div>
              )}
          </Hidden>

          {!isEmpty(this.props.shoot) &&
            confirmDuplicateShootDialogueOpen && (
              <div>
                <DuplicateConfirmDialog
                  onUpdateShootStatus={shootId =>
                    this.updateShootStatus(shootId)
                  }
                  onClickEdit={shootId => this.goToShoot(shootId)}
                />
              </div>
            )}
          {/* MOBILE VIEW */}
          {/* {accessLevel === 1 && ( */}
          <Hidden mdUp>
            <Fab
              color="primary"
              className={this.props.classes.addShootlegendButton}
              onClick={() => this.toggleShootDialog(true)}
            >
              <AddIcon style={{ color: "white" }} />
            </Fab>
          </Hidden>
          {/* )} */}
        </LoadingOverlay>
      </Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    authentication: state.authentication,
    users: state.misc.users,
    roles: state.misc.roles,
    shoots: state.shoots.shoots,
    activeCompany: state.companies.activeCompany,
    accessLevel: state.companies.accessLevel,
    companies: state.companies,
    companyList: state.clients.companiesList,
    crew: state.crew,
    shootsLength: state.shoots.shootsLength,
    shoot: state.shoots.editShoot,
    editShootDialogOpen: state.shoots.editShootDialogOpen,
    confirmDuplicateShootDialogueOpen:
      state.shoots.confirmDuplicateShootDialogueOpen,
    searchedShoot: state.misc.equipment,
    defaultFilters: state.users.userDefaultFilters,
    authenticatedUser: state.authentication.authenticatedUser,
  }
}

export default compose(
  connect(mapStateToProps),
  withStyles(styles, { withTheme: true })
)(MyShoots)
